export default "__VITE_ASSET__CI45tYXn__"